@if (mask() && formControl) {
  <div
    [ngClass]="{
      'd-flex': suffix(),
      'loading-input': isLoading(),
    }"
    class="position-relative"
  >
    <ng-container *ngTemplateOutlet="copyBtnTemplate"></ng-container>
    <input
      #inputElement
      [type]="type()"
      [formControl]="formControl"
      [coreAutoHttps]="enableAutoHttps()"
      [placeholder]="placeholder()"
      [style.background-image]="!backgroundImageView() ? 'none' : ''"
      [mask]="mask()"
      [class]="class()"
      [coreCopyPrefix]="!!inputPrefix()"
      [copyPrefix]="inputPrefix()"
      [showMaskTyped]="true"
      [keepCharacterPositions]="true"
      [corePositiveNumbers]="noNegative()"
      [coreMaxValue]="maxValue()"
      [coreNumberValue]="isNumber()"
      [readonly]="readonly()"
      [ngClass]="{
        'bg-transparent': !global(),
        'form-control-lg form-control-solid': global(),
        'is-invalid':
          !skipValidation() && control()!['touched'] && control()!.invalid,
        'is-valid': !skipValidation() && control()!.valid && formControl.value,
        'suffix-input': suffix(),
        'padding-copy': copyBtn(),
        'input-disabled': disabled(),
      }"
      coreNoLeadingSpace
      class="form-control form-control-lg"
      (input)="onInputActivity()"
    />
    <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
  </div>
} @else {
  <div
    [ngClass]="{
      'd-flex': suffix(),
      'loading-input': isLoading(),
    }"
    class="position-relative"
  >
    <ng-container *ngTemplateOutlet="copyBtnTemplate"></ng-container>
    @if (formControl) {
      <input
        #inputElement
        [type]="type()"
        [formControl]="formControl"
        [coreAutoHttps]="enableAutoHttps()"
        [coreCopyPrefix]="!!inputPrefix()"
        [copyPrefix]="inputPrefix()"
        [placeholder]="placeholder()"
        [class]="class()"
        [coreMaxValue]="maxValue()"
        [corePositiveNumbers]="noNegative()"
        [coreNumberValue]="isNumber()"
        [readonly]="readonly()"
        [ngClass]="{
          'bg-transparent': !global(),
          'form-control-lg form-control-solid': global(),
          'is-invalid':
            !skipValidation() && control()!['touched'] && control()!.invalid,
          'is-valid':
            !skipValidation() && control()!.valid && formControl.value,
          'suffix-input': suffix(),
          'padding-copy': copyBtn(),
          'input-disabled': disabled(),
        }"
        coreNoLeadingSpace
        class="form-control form-control-lg"
        (input)="onInputActivity()"
      />
    } @else {
      <div
        [ngClass]="{
          'd-flex': suffix(),
          'loading-input': isLoading(),
        }"
        class="position-relative"
      >
        <ng-container *ngTemplateOutlet="copyBtnTemplate"></ng-container>
        <input
          #inputElement
          [(ngModel)]="value"
          [type]="type()"
          [placeholder]="placeholder()"
          [class]="class()"
          [coreCopyPrefix]="!!inputPrefix()"
          [copyPrefix]="inputPrefix()"
          [coreMaxValue]="maxValue()"
          [corePositiveNumbers]="noNegative()"
          [readonly]="readonly()"
          [disabled]="disabled() || isLoading()"
          [ngClass]="{
            'bg-transparent': !global(),
            'form-control-lg form-control-solid': global(),
            'suffix-input': suffix(),
            'padding-copy': copyBtn(),
          }"
          coreNoLeadingSpace
          class="form-control form-control-lg"
          (input)="onInputActivity()"
        />
        <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
      </div>
    }
    <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
  </div>
}
@if (formControl && !skipValidation() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (alertMessage()) {
  <div class="mt-2">
    <ui-alert
      [severity]="'danger'"
      [iconClass]="'fs-3 text-danger'"
      [class]="'m-0'"
      >{{ alertMessage() }}
    </ui-alert>
  </div>
}
@if (showHint()) {
  <div class="input-hint-panel mt-2" role="alert" aria-live="polite">
    <div class="input-hint-panel__icon">
      <ui-keenicon name="information-2" class="fs-4 text-primary"></ui-keenicon>
    </div>
    <p class="input-hint-panel__text mb-0">{{ tooltip() }}</p>
    <button
      type="button"
      class="input-hint-panel__close btn-close btn-close-sm"
      aria-label="Dismiss hint"
      (click)="dismissHint()"
    ></button>
  </div>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
@if (lockedMessage()) {
  <div
    class="form-text d-inline-flex align-items-center gap-2 text-field-locked"
  >
    <i class="bi bi-lock-fill"></i>
    <span>{{ lockedMessage() }}</span>
  </div>
}

<ng-template #suffixTemplate>
  @if (suffix()) {
    <span
      class="form-control form-control-lg w-auto pointer-events-none suffix-text"
      [ngClass]="{
        'bg-transparent': !global(),
        'form-control-solid': global(),
      }"
      >{{ suffix() | lowercase }}</span
    >
  }
</ng-template>
<ng-template #copyBtnTemplate>
  @if (copyBtn()) {
    <div
      [coreCopyToClipboard]="formControl ? formControl.value : value()"
      class="copy-btn cursor-pointer"
    >
      <ui-keenicon name="copy" class="fs-2 text-primary"></ui-keenicon>
    </div>
  }
</ng-template>
